import { render, staticRenderFns } from "./choiceType.vue?vue&type=template&id=93f99aca"
import script from "./choiceType.vue?vue&type=script&lang=js"
export * from "./choiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports